/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prettier/prettier */
/* eslint-disable react-hooks/rules-of-hooks */
import './confirmShareDialog.scss'
import { useState, useEffect } from "react";
import { DialogTitle, DialogContent } from "@mui/material"
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import UKDialog from "@/common-components-src/components/UKDialog/index";
import { Button } from "@mui/material";

type Props = {
  open: boolean;
  closeFn: any;
  confirmShareMsg:any;
};

const DialogStyle = {
  "& .MuiDialog-paper": {
      width: "592px",
      margin: "0",
  },
  '& .MuiDialogTitle-root': {
    fontSize: "16px",
    fontWeight: "bold",
    lineHeight: "20px",
    padding: "20px 24px 20px 24px",
  },
}

const ContentStyle = {
  display: "flex",
  flexDirection: "column",
  padding: "24px",
  paddingTop: "0",
}

export default function ConfirmShareDialog({ open, closeFn, confirmShareMsg } : Props){

  const [isOpen, setIsOpen] = useState(false);

  const closeHandler = () => {
    setIsOpen(false);
    closeFn && closeFn();
  }
  const close = () => {
    setIsOpen(false);
  }
  useEffect(() => {
    setIsOpen(open);
  }, [open])

  return(
    <UKDialog open={isOpen} onClose={closeHandler} showCloseBtn={false} sx={DialogStyle} className="confirmShareWrap">
      {/* <DialogTitle />
      <IconButton
        aria-label="close"
        onClick={closeHandler}
        sx={(theme) => ({
          position: "absolute",
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton> */}
      <DialogContent>
        <p className="text">{confirmShareMsg ? confirmShareMsg : 'All rewards have been distributed. Inviting friends will not earn you any more rewards. Do you wish to continue?'}</p>
        <div className="btnWwap">
            <Button className="btn btn1" variant="outlined" onClick={close}>No</Button>
            <Button className="btn btn2" variant="contained" onClick={closeHandler}>Yes</Button>
        </div>
      </DialogContent>
      
    </UKDialog>
  )
}
